import { useQuery } from '@tanstack/react-query'

import { useQueryErrorAlert } from '@hooks/useQueryErrorAlert'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import { fetchTemplates, initialState } from '../services/fetchTemplates'
import type { ContractinstellingenSearchFilters } from '../types/ContractinstellingenSearch'

export { queryKey, useTemplatesSearch }

const queryKey = 'aanvraag-templates'

const useTemplatesSearch = ({
  externalFilters: filters,
}: {
  externalFilters: ContractinstellingenSearchFilters
}) => {
  const { hasPermissions } = useAuthenticatedUser()

  const {
    data,
    isFetching: isLoading,
    error,
    errorUpdatedAt,
  } = useQuery({
    queryKey: [queryKey, filters],
    queryFn: () => fetchTemplates(filters),
    enabled: hasPermissions && !!filters.combi,
  })

  useQueryErrorAlert(error, errorUpdatedAt, 'Fout bij ophalen van templates')

  return {
    data: data || initialState.data,
    isLoading,
    filters,
    error,
  }
}
